import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "../../reducers";

const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const isLogged = useSelector((state: RootState) => state.auth.isLogged);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLogged ? (
          children
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: location } }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
